












import { Component, Vue, Prop } from 'vue-property-decorator';

import ShareCampaign from '@/components/ShareCampaign/ShareCampaign.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';

import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    FlexButton,
    ShareCampaign
  }
})
export default class TemplateModal extends Vue {
  @Prop({ default: false }) isDetail?: boolean;
  @Prop({ default: false }) sellingCoinsCampaign?: boolean;
  @Prop() shareLink?: string;
  @Prop() modalViewEvent?: string;

  get textWelcome() {
    return 'Welcome Coins!';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get campaignType() {
    return this.sellingCoinsCampaign ? 'sellingCoins' : 'freeCoins';
  }

  get title() {
    return `${this.$t(`${this.tPrefix}.` + this.campaignType + `.title`)}`;
  }

  get description() {
    return `${this.$t(
      `${this.tPrefix}.` + this.campaignType + `.description`
    )}`;
  }

  mounted() {
    if (this.modalViewEvent) {
      segmentIo.modal(this.modalViewEvent);
    }
  }

  onClose(event: any) {
    eventBus.$emit('closeModal');
  }

  get gaTracking() {
    return {
      eventCategory: `${
        this.sellingCoinsCampaign
          ? 'Selling Coins Campaign '
          : 'Free Coins Campaign '
      } ${this.isDetail ? 'Detail' : ''} | Share campaign options (modal)`,
      eventAction: 'click'
    };
  }

  get tPrefix() {
    return 'sellCoins.modals.shareCampaign';
  }
}
